document.addEventListener('DOMContentLoaded', updateDeliveryNoteTime);
function updateDeliveryNoteTime() {
    const now = new Date();
    const dayOfWeek = now.getDay();
    const hours = now.getHours();
    const minutes = now.getMinutes();
	let delivery_day = 'Morgen'
	let delivery_text = 'Wenn Sie jetzt bestellen';
    const targetTime = new Date();
    targetTime.setHours(12, 30, 0, 0);
	const timeRemaining = targetTime - now;
	const hoursRemaining = Math.floor(timeRemaining / (1000 * 60 * 60));
	const minutesRemaining = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
	if (dayOfWeek === 6 || dayOfWeek === 0 || (dayOfWeek === 5 && (hours === 12 && minutes >= 30 || hours > 12))) {
		delivery_day = 'Dienstag'
	} else if(dayOfWeek <= 5 && (hours === 12 && minutes < 30 || hours < 12)) {
		delivery_text = 'Bei Bestellung innerhalb von ' +
        	hoursRemaining + ' Stunde(n) und ' + minutesRemaining + ' Minuten';		
	} else {
		const date = new Date();
		date.setDate(date.getDate() + 2);
		delivery_day = date.toLocaleDateString('de-DE', { weekday: 'long' });
	}
    document.getElementById('delivery-countdown').innerHTML = '<b>Kostenlose Express-Lieferung: '+delivery_day+'</b>  - '+delivery_text+'.';
    setTimeout(updateDeliveryNoteTime, 60000);
}